import { render, staticRenderFns } from "./Lokasi.vue?vue&type=template&id=38ff598d&"
import script from "./Lokasi.vue?vue&type=script&lang=js&"
export * from "./Lokasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports